import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    weburl:"http://szsbg.7inc.com.cn/",
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
